/* global $ */

import { hasIOSupport } from '../helpers/feature-detects';

const $socialNav = $.$body.find('.social-nav');

// const $main = document.querySelector('.site-main');
// const sfooterClass = 'sticky_sentinel_footer';
// const sentinel = document.createElement('div');
// sentinel.classList.add(sfooterClass, 'social-hide');
// $main.appendChild(sentinel);

// const $footer = $.$body.find('#site-footer');
// let footerHeight = $footer.innerHeight();

// $(window).on('resize', () => { footerHeight = $footer.innerHeight(); }).resize();

// opens shares in popup
$.$body.on('click', '.social .social-pop', function(e) {
  if ($(window).width() > 967) {
    e.preventDefault();
    window.open(
      this.href,
      '',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=350,width=600',
    );
  }
});

const $socialHiders = document.querySelectorAll(
  '.social-hide,[data-js-social-hide]',
);

if ($socialHiders.length && hasIOSupport) {
  let intersects = [];
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.target) {
          intersects.push(entry.target);
          // console.log(
          //   `added ${entry.target.className}`,
          //   intersects.length,
          //   intersects.map((t) => t.className),
          // );
        } else {
          intersects = intersects.filter((target) => target !== entry.target);
          // console.log(
          //   `removed ${entry.target.className}`,
          //   intersects.length,
          //   intersects.map((t) => t.className),
          // );
        }
        if (intersects.length) {
          $socialNav.addClass('behind animate');
        } else {
          $socialNav.removeClass('behind animate');
        }
      });
      // const intersects = entries.filter((entry) => entry.isIntersecting);
      // if (intersects.length) {
      //   console.log(intersects[0]);
      //   $socialNav.addClass('behind animate');
      // } else {
      //   console.log('no intersect', intersects, entries);
      //   $socialNav.removeClass('behind animate');
      // }
    },
    {
      rootMargin: '-40% 0px -40% 0px',
      threshold: [0, 1],
    },
  );

  $socialHiders.forEach((hider) => observer.observe(hider));
} else {
  $socialNav.addClass('behind animate');
}

/**
 * Handle click to copy
 */
$.$body.on('click', '.js-click-to-copy', (e) => {
  e.preventDefault();
  const $copyLink = $(e.currentTarget).removeClass('copied');
  const $link = $copyLink.find('.click-to-copy-inner-range');
  const copiedCheckTitle = $copyLink.find('.check-icon').attr('title');
  if ($link) {
    const linkNode = $link.get(0);
    const range = document.createRange();

    range.selectNode(linkNode);
    window.getSelection().addRange(range);
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        $copyLink.addClass('copied').attr('title', copiedCheckTitle);
        console.log(linkNode);
        setTimeout(() => {
          $copyLink
            .removeClass('copied')
            .blur()
            .removeAttr('title');
        }, 4000);
      }
    } catch (err) {
      console.log('Oops, unable to copy');
    }
    window.getSelection().removeAllRanges();
  } else {
    console.log('No Text Found');
  }
});
